import React, { useEffect } from "react";
import "./chooseProd.css";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../../../AxiosInstance";
import { alertError } from "../../Helper/Alerts";
import OtherPageHeader from "../../../components/OtherHeader";
import { TPEProfile } from "../../../svg/SvgImages";
import { getUserInfo } from "../../../utils";
import choosePH from "../../../assets/choose_ph.png";
import chooseInvestor from "../../../assets/become_investor.png";
import { ADMIN_ROLES } from "../../../constants";
export default function ChooseProd() {
  const navigate = useNavigate();

  useEffect(() => {
    const userInfo = getUserInfo();
    if (userInfo?.role) {
      navigateToPage(userInfo.role);
    }
  });

  const navigateToPage = (role) => {
    if (role === "INVESTOR") {
      navigate("/investPref");
    } else if (role === "POLICY_MASTER") {
      navigate("/add-policy");
    } else if (role === "PARTNER") {
      navigate("/partner-registration");
    }
  };

  const createNewUser = (value) => {
    const payload = {
      firstName: value.firstName,
      lastName: value.lastName,
      email: value.email,
      dob: new Date(value.dob),
      userRole: value.userRole,
      token: value.token,
    };

    if (value.referralCode) {
      payload.referralCode = value.referralCode;
    }

    AxiosInstance()
      .post("/auth/signup", payload)
      .then((resp) => {
        let { data } = resp;
        localStorage.setItem("token", data.token);
        return navigateToPage(value.userRole);
      })
      .catch((err) => {
        alertError(err?.response?.data?.message);
      });
  };

  const createNewRole = (value) => {
    const payload = { userRole: value.userRole };
    AxiosInstance()
      .post("/auth/addNewRole", payload)
      .then((resp) => {
        if (resp.status === 201) {
          localStorage.setItem("token", resp.data.token);
          const stored = JSON.parse(localStorage.getItem("data"));
          delete stored.role;
          localStorage.setItem("data", JSON.stringify(stored));
          return navigateToPage(payload.userRole);
        }
      })
      .catch((err) => {
        alertError(err.response.data.message);
      });
  };

  const onSubmit = (role) => {
    const payload = JSON.parse(localStorage.getItem("data"));
    payload.userRole = role;
    payload.token = localStorage.getItem("token");
    if (ADMIN_ROLES.includes(payload.role)) {
      return createNewRole(payload);
    }
    delete payload.role;
    return createNewUser(payload);
  };
  return (
    <div>
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="navbar-light"
        pageType="REGISTER"
      />
      <section className="section-preview py-3">
        <div className="container">
          <div className="row mx-1">
            <div className="col-md-4 mb-4 px-4">
              <div className="card testimonial-card border-0 tre_sm-shadow card-1 h-100">
                <div className="card-up indigo lighten-1"></div>
                <div className="Policy-Holder mx-auto white py-4">
                  <img
                    src={choosePH}
                    className="img-responsive mx-auto card-img"
                    alt="Policy Holder"
                  />
                </div>
                <div className="card-body card-Policy-body text-center">
                  <h4 className="card-title d-block">
                    Having trouble paying your premiums
                  </h4>
                  <div className="hr"></div>
                  <p>
                    Ease your financial worries with our customized solutions
                  </p>
                  <button
                    className="btn-block btn-holder btn-md"
                    onClick={() => {
                      onSubmit("POLICY_MASTER");
                      // window.location.href = '/myPolicy';
                    }}
                  >
                    Register as a Policyholder
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4 px-4">
              <div className="card testimonial-card border-0 tre_sm-shadow card-3 h-100">
                <div className="Policy-Exchange mx-auto white py-4">
                  <img
                    src={chooseInvestor}
                    className="img-responsive mx-auto card-img"
                    alt="Policy-Exchange"
                  />
                </div>
                <div className="card-body card-Invest-body text-center">
                  <h4 className="card-title d-block">
                    Seeking low-risk, high-return investments
                  </h4>
                  <div className="hr"></div>
                  <p>
                    Explore our &apos;Policy Center&apos; to pick investments
                    that suit you best
                  </p>
                  <button
                    className="btn-block btn-investor btn-md"
                    onClick={() => {
                      onSubmit("INVESTOR");
                    }}
                  >
                    Become an Investor
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4 px-4">
              <div className="card testimonial-card border-0 tre_sm-shadow card-2 h-100">
                <div className="Policy-Holder mx-auto white py-3">
                  {/* <img
                    src="https://i.postimg.cc/wjdtLKpC/Group-913.png"
                    className="img-responsive mx-auto card-img"
                    alt="Policy Holder"
                  /> */}
                  <TPEProfile classProps="w-100" />
                </div>
                <div className="card-body card-Policy-body text-center">
                  <h4 className="card-title d-block">
                    {" "}
                    Looking for handsome earning opportunities{" "}
                  </h4>
                  <div className="hr"></div>
                  <p>Partner with us for an exciting & rewarding journey</p>
                  <button
                    className="btn-block btn-partner btn-md"
                    onClick={() => {
                      onSubmit("PARTNER");
                    }}
                  >
                    Partner with Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
